<script setup>
import Header from '@/modules/Signup/layouts/partials/Header.vue';
import Footer from '@/modules/Signup/layouts/partials/Footer.vue';
import VLoader from '@/modules/Signup/components/VLoader.vue';
import { useVLoader } from '@/modules/Signup/composables/useVLoader';
import { onBeforeRouteUpdate, onBeforeRouteLeave } from 'vue-router';

// Apply CSS
// TODO: refactor further to accommodate dynamic changes, i.e., base, component, utilities
import '@/modules/Signup/styles/index.scss';

// Initialize the loader
const { isLoading, loadingText, startLoading, stopLoading } = useVLoader();

// Show loader during route transitions
onBeforeRouteUpdate((to, from, next) => {
    startLoading('Loading...');
    next();
    // The loader will be hidden after the component is mounted
    setTimeout(() => {
        stopLoading();
    }, 500); // Add a small delay to ensure smooth transition
});

onBeforeRouteLeave((to, from, next) => {
    startLoading('Loading...');
    next();
});
</script>

<template>
    <div class="module-signup">
        <Header />

        <main class="tw-bg-white">
            <router-view />
        </main>

        <Footer />

        <!-- Show loader during route transitions -->
        <VLoader
            v-if="isLoading"
            :text="loadingText"
        />
    </div>
</template>
